import { StyledImageWrapper } from 'modules/campaigns/lib/components/CampaignPreviewThumbnail';
import { Skeleton } from 'ui/skeleton';
import {
  StyledContentHeading,
  StyledNBACampaignsList,
  StyledCampaignPreviewThumbnail,
  StyledNBACampaignsItemsSkeleton,
  StyledSkeletonWrapper,
  StyledGradientMask,
  StyledGradientMaskContainer,
} from 'modules/ai/nba/components/campaigns/NBACampaignsSlideOver.styles';

const NBACampaignSkeletonItem = () => (
  <StyledNBACampaignsItemsSkeleton>
    <StyledCampaignPreviewThumbnail>
      <StyledImageWrapper>
        <Skeleton />
      </StyledImageWrapper>
    </StyledCampaignPreviewThumbnail>
    <StyledSkeletonWrapper>
      <Skeleton width={200} height={16} isRound={true} />
      <Skeleton width={150} height={16} isRound={true} />
    </StyledSkeletonWrapper>
  </StyledNBACampaignsItemsSkeleton>
);

export const NBACampaignSlideOverBodySkeleton = () => (
  <div data-test="nba-eligible-slideover-content-loading">
    <StyledContentHeading>
      <Skeleton width={200} height={16} />
    </StyledContentHeading>
    <StyledGradientMaskContainer>
      <StyledNBACampaignsList data-test="nba-eligible-campaigns-skeleton-list-container">
        <NBACampaignSkeletonItem />
        <NBACampaignSkeletonItem />
        <NBACampaignSkeletonItem />
      </StyledNBACampaignsList>
      <StyledGradientMask />
    </StyledGradientMaskContainer>
  </div>
);
